import { create } from 'zustand';

const initialState = {
    sourceKey: null,
    runs: [],
    selectedRunId: null,
    board: null,
    history: [],
    loadingRuns: false,
    loadingBoard: false,
    loadingHistory: false,
    mutating: false,
    error: null,
    historyError: null,
    selectedTask: null,
};

export const useOperationalExecutionStore = create((set) => ({
    ...initialState,
    setSourceKey: (sourceKey) => set({ sourceKey }),
    setRuns: (runs) => set({ runs: Array.isArray(runs) ? runs : [] }),
    setSelectedRunId: (selectedRunId) => set({ selectedRunId }),
    setBoard: (board) => set({ board }),
    setHistory: (history) => set({ history: Array.isArray(history) ? history : [] }),
    setLoadingRuns: (loadingRuns) => set({ loadingRuns }),
    setLoadingBoard: (loadingBoard) => set({ loadingBoard }),
    setLoadingHistory: (loadingHistory) => set({ loadingHistory }),
    setMutating: (mutating) => set({ mutating }),
    setError: (error) => set({ error }),
    setHistoryError: (historyError) => set({ historyError }),
    clearError: () => set({ error: null }),
    openTask: (selectedTask) => set({ selectedTask }),
    closeTask: () => set({ selectedTask: null }),
    reset: () => set(initialState),
}));
